
import * as _components from './component'
export default {
    install: function (Vue, options) {
        // //  全局方法或数据
        // Object.keys(_gfunction).forEach((key) => {
        //     Vue[key] = _gfunction[key]
        // })
        // //  Vue.myGlobalMethod()
        // //  指令
        // Object.keys(_directives).forEach((key) => {
        //     Vue.directive(key, _directives[key])
        // })
        // //  混合
        // Vue.mixin(mixin)
        // //  过滤
        // Object.keys(_filters).forEach((key) => {
        //     Vue.filter(key, _filters[key])
        // })
         //  组件
         Object.keys(_components).forEach((key) => {
            Vue.component(key, _components[key])
         })
        // //  事例方法
        // Object.keys(_utils).forEach((key) => {
        //     Vue.prototype[key] = _components[key]
        // })
    }
}



// WEBPACK FOOTER //
// ./src/global/index.js